import CloseCircle from '../../../assets/icons/CloseCircle';
import Button from '../../../ui/Button';
import dropCards from '../../../assets/dropCards.png';
import Modal from '../../../ui/Modal';
import MintModal from './MintModal';
import { useContext } from 'react';
import { ProfileContext } from '../../../contexts/ProfileContext';
import Loader from '../../../ui/Loader';
import { AuthContext } from '../../../contexts/AuthContext';
import ButtonNew from '../../../ui/ButtonNew';
// import WhyMintModal from './WhyMintModal';

function UnclaimedBack({ certificateId, ic, setAskToConnectWallet }) {
    const { mintYourIc, claimYourIc, minting, claiming } = useContext(ProfileContext);
    const { state } = useContext(AuthContext);
    const { user } = state;
    const userProfile = user[0];

    return (
        <div className="bg-neutral50C border flex flex-col items-center justify-center relative border-borderUnderline rounded-md  px-[29.2px] h-full w-full overflow-hidden ">

            <img className="mx-auto w-11 my-6 mb-1" src={dropCards} alt="" />
            <div>
                <ButtonNew
                    onClick={() => {
                        claimYourIc(certificateId);
                    }}
                    className="text-xs font-medium"
                    size="xs"
                    fixedMinWidth={true}
                >
                    {claiming ? <Loader w="w-4" h="h-4" /> : 'Claim'}
                </ButtonNew>
                <p className="text-[10px] font-semibold text-center my-2 ">OR</p>

                <ButtonNew
                    onClick={() => {
                        if (ic?.blockchain.name !== 'solana' && !userProfile?.evmAddress) {
                            setAskToConnectWallet('phantom');
                            return;
                        } else if (ic?.blockchain.name === 'solana' && !userProfile?.walletAddress) {
                            setAskToConnectWallet('phantom');
                            return;
                        }
                        mintYourIc(certificateId, userProfile?.walletAddress);
                    }}
                    className="text-xs font-medium"
                    size="xs"
                    fixedMinWidth={true}
                >
                    {minting ? <Loader w="w-4" h="h-4" /> : ' Mint as NFT'}
                </ButtonNew>
            </div>
            <div className="flex items-center justify-center mt-1">
                <div className="flex items-center  gap-1  ">
                    <img className="w-5 h-5 rounded-full" src={ic?.blockchain.image} alt={ic?.blockchain.name} />
                    <p className="text-[.5rem] flex-1">
                        This Ic can be minted on <span className="capitalize">{ic?.blockchain?.name}</span> blockchain
                    </p>
                </div>
            </div>
            <div>
                <Modal>
                    <Modal.Button
                        className="text-xs cursor-pointer text-center my-3 underline font-medium "
                        opens="whymint"
                    >
                        Why Mint ?
                    </Modal.Button>
                    <Modal.Window name="whymint">
                        <MintModal />
                    </Modal.Window>
                </Modal>
            </div>
        </div>
    );
}

export default UnclaimedBack;
